<template>
	<div>
		<locum-application-sent />
		<locum-upcoming-bookings />
		<locum-past-bookings />
		<locum-increase-availability-ad />
	</div>
</template>

<script>
import LocumApplicationSent from '@/components/ui/dashboard/locum/cards/LocumApplicationSent';
import LocumUpcomingBookings from '@/components/ui/dashboard/locum/dropdowns/LocumUpcomingBookings';
import LocumPastBookings from '@/components/ui/dashboard/locum/dropdowns/LocumPastBookings';

import LocumIncreaseAvailabilityAd from '@/components/ui/dashboard/locum/cards/LocumIncreaseAvailabilityAd';

export default {
	name: 'LocumSuccessApplicationSent',
	components: {
		LocumApplicationSent,
		LocumUpcomingBookings,
		LocumPastBookings,
		LocumIncreaseAvailabilityAd,
	},
	data: () => ({}),
};
</script>
